export const mapDefaultProps = {
  center: {
    lat: 44.0165,
    lng: 21.0059,
  },
  zoom: 11,
  maxZoom: 16,
};
